import React from 'react';

import './index.less';

import blueTick from 'ck-core-client/graphics/checkout/blue-tick.svg';
import { lang } from 'ck-website/source/components/GuaranteesBanner/lang';

import { format, addDays, isDate } from 'date-fns';
import { FRIENDLY } from 'ck-core/source/data/DateFormat';
export const DATE_FORMAT = FRIENDLY;

export interface Props {
	showCancelAnytime: boolean;
	startDate?: Date | Symbol;
	isLifetime?: boolean;
}

export const GuaranteesBanner: React.SFC<Props> = ({
	isLifetime,
	showCancelAnytime,
	startDate
}) => (
	<div className="GuaranteesBanner">
		<div className="GuaranteesBanner__row">
			<img src={blueTick} />
			<div className="GuaranteesBanner__text">
				<div className="GuaranteesBanner__title">{lang.changePlan.title}</div>
				<div className="GuaranteesBanner__message">
					{isLifetime ? lang.changePlan.lifetimeMessage : lang.changePlan.message}
				</div>
			</div>
		</div>
		<div className="GuaranteesBanner__row">
			<img src={blueTick} />
			<div className="GuaranteesBanner__text">
				<div className="GuaranteesBanner__title">
					{showCancelAnytime ? lang.cancelAnytime.title : lang.moneyBack.title}
				</div>
				<div className="GuaranteesBanner__message">
					{showCancelAnytime
						? lang.cancelAnytime.message
						: isDate(startDate)
							? lang.moneyBack.message({
								to: format(addDays(startDate as Date, 30), FRIENDLY),
								from: format(startDate as Date, FRIENDLY)
							})
							: lang.moneyBackRedeemed.message}
				</div>
			</div>
		</div>
		{/* <div className="GuaranteesBanner__row">
			<img src={blueTick} />
			<div className="GuaranteesBanner__text">
				<div className="GuaranteesBanner__title">{lang.coupons.title}</div>
				<div className="GuaranteesBanner__message">
					{lang.coupons.message}
				</div>
			</div>
		</div> */}
	</div>
);
